import {Controller, useFormContext} from "react-hook-form";
import {FormField, FormFieldError} from "../../../../../../design-system/form-field";
import {Select, Space} from "antd";
import {
  BundleBookingIntervalOptions,
  BundleSessionSessionPeriodBookingIntervalFormFieldType,
} from "./types";

export const bundleBookingIntervals = ["1day", "3days", "5days", "1week", "2weeks"];
export const bundleIntervalOptions: BundleBookingIntervalOptions = [
  {
    label: "1 day",
    value: "1day",
  },
  {
    label: "3 days",
    value: "3days",
  },
  {
    label: "5 days",
    value: "5days",
  },
  {
    label: "1 week",
    value: "1week",
  },
  {
    label: "2 weeks",
    value: "2weeks",
  },
];

export function BundleSessionSessionPeriodBookingIntervalFormField() {
  const {control} =
    useFormContext<BundleSessionSessionPeriodBookingIntervalFormFieldType>();

  return (
    <div>
      <FormField
        id={"bundleBookingInterval"}
        label={"Booking interval"}
        renderInput={(id) => (
          <Controller
            control={control}
            name="bookingInterval"
            render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
              <Space direction="vertical" size={16} style={{display: "flex"}}>
                <Select
                  id={id}
                  size="large"
                  status={error?.message ? "error" : undefined}
                  style={{width: "100%"}}
                  onChange={onChange}
                  value={value}
                  ref={ref}
                  onBlur={onBlur}
                  options={bundleIntervalOptions}
                  placeholder={"Please select"}
                />
                <FormFieldError errorMessage={error?.message} />
              </Space>
            )}
          />
        )}
      />
    </div>
  );
}
